// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__fsN6R","iconWrapper":"index_iconWrapper__igJ3M","icon":"index_icon__qnKCc","text":"index_text__bmCWC","rightIcon":"index_rightIcon__w7rxu"};